import { AfterViewInit, Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

import { QPointContextbarService } from '../contextbar/contextbar.service/contextbar.service';
import { ContentContainerBottomDirective } from './content-container-bottom.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'qpoint-content-container',
    templateUrl: './content-container.component.html',
    styleUrls: ['./content-container.component.scss'],
    imports: [
        CommonModule
    ]
})
export class QPointContentContainerComponent implements AfterViewInit {
  @Input() fullHeight = true;

  @Output() contentScroll: EventEmitter<void> = new EventEmitter();

  @ContentChild(ContentContainerBottomDirective, {read: TemplateRef}) lastChangeInfo: TemplateRef<unknown>;

  constructor(public contextbarService: QPointContextbarService) { }

  ngAfterViewInit() {
    document.getElementsByClassName('content-container')[0].addEventListener('scroll', () => {
      this.contentScroll.emit();
    });
  }
}
